import type {
  ActionReference,
  ConditionFieldDescription,
  InputDescription,
} from "@smartsuite/automation-engine-api";
import type { ActionCandidate, TriggerCandidate } from "../types/candidate";

export const isOptionExists = (
  actionCandidate: { trigger: TriggerCandidate; actions: ActionCandidate[] },
  inputId: string,
  optionValue: string,
  // actionId?: string,
  actionReference?: ActionReference,
  isCondition?: boolean,
): boolean => {
  let candidate: ActionCandidate | TriggerCandidate | undefined;
  if (actionReference !== undefined) {
    candidate = actionCandidate.actions.find(
      (action) =>
        JSON.stringify(action.actionReference) ===
        JSON.stringify(actionReference),
    );
  } else {
    candidate = actionCandidate.trigger;
  }

  if (candidate !== undefined) {
    let found: ConditionFieldDescription | InputDescription | undefined;
    if (isCondition) {
      found = candidate.description?.conditionFields.find(
        (input) => input.conditionFieldId === inputId,
      );
    } else {
      found = candidate.description.inputs.find(
        (input) => input.inputId === inputId,
      );
    }
    if (found !== undefined) {
      if (found.editor?.editor.oneofKind === "select") {
        const option = found.editor?.editor.select.options.find(
          (option) => option.value === optionValue,
        );
        return option !== undefined;
      }
      if (found.editor?.editor.oneofKind === "status") {
        const option = found.editor?.editor.status.options.find(
          (option) => option.value === optionValue,
        );
        return option !== undefined;
      }
    }
  }
  return true;
};
